import { render, staticRenderFns } from "./FeedbackBox.vue?vue&type=template&id=6e26674c"
import script from "./feedback-box.ts?vue&type=script&lang=ts&external"
export * from "./feedback-box.ts?vue&type=script&lang=ts&external"
import style0 from "./feedback-box.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports